import { render, staticRenderFns } from "./deptTree.vue?vue&type=template&id=57d5040c&scoped=true"
import script from "./deptTree.vue?vue&type=script&setup=true&lang=js"
export * from "./deptTree.vue?vue&type=script&setup=true&lang=js"
import style0 from "./deptTree.vue?vue&type=style&index=0&id=57d5040c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5040c",
  null
  
)

export default component.exports